export default __webpack_public_path__ + "static/help-donation-f3a31ec68d6088516f3ff503b7ff134a.png";